import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PlayBuilderForm } from './play-record-play-builder/play-builder-form.model';
import { PlayFileImportForm } from '@r1-compass-library/models/play/play-file-import-form.model';

@Injectable()
export class PlayRecordFormService {
    // Needs imperative form saving/deactivating handling
    playBuilderForm: FormGroup<PlayBuilderForm> = new FormGroup(new PlayBuilderForm());

    // Fully reactive handling
    playImporterForm: FormGroup<PlayFileImportForm> = new FormGroup(new PlayFileImportForm());
}
